import { connect } from 'react-redux'

import { actions as LKModalActions } from 'shared/LKModal'

import { actions as DetailsContainerActions } from '../../../../DetailsContainer'
import { translateLKMessage } from '../../../translator'
import { deleteAssistant, deleteAssistantLoading } from 'src/store/loan'

const FETCHER_NAME = 'DeleteLoanOfficerAssistant'

export default connect(
  (state) => ({
    // loading: getPending(FETCHER_NAME)(state),
    loading: deleteAssistantLoading(state),
  }),
  (dispatch, { ID, hash }) => ({
    openConfirmation: (ManagerID) => {
      dispatch(
        LKModalActions.openConfirmation('DeleteLoanOfficerAssistantConfirmation', {
          message: translateLKMessage('CONFIRM_LOAN_MANAGER_REMOVE'),
          ManagerID,
        }),
      )
    },

    deleteAssistant: ({ ManagerID }) => {
      // dispatch(
      //   fetchSFM({
      //     instanceName: FETCHER_NAME,
      //     callApi: Loan.deleteAssistant,
      //     callApiArgs: [
      //       {
      //         LoanID: ID,
      //         HashSum_LoanID_: hash,
      //         ManagerID,
      //       },
      //     ],
      //     resolve: () => {
      //       dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'officerassistant' }))
      //     },
      //     reject: ({ Error }) => {
      //       dispatch(LKModalActions.openError(translateLKMessage(Error.Message || Error.Text)))
      //     },
      //   }),
      // )

      //UPDATED API REQUEST loan_oper_api page: assistantdelete
      dispatch(
        deleteAssistant({
          LoanID: ID,
          HashSum_LoanID_: hash,
          ManagerID,
        }),
      ).then((response) => {
        if (!deleteAssistant.fulfilled.match(response)) {
          dispatch(LKModalActions.openError(translateLKMessage(response.payload)))
          return
        }
        dispatch(DetailsContainerActions.fetchPage({ type: 'Loan', ID, hash, page: 'officerassistant' }))
      })
    },
  }),
)
